import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Select, Switch, InputNumber } from "antd";

const UpdateCouponForm = ({ visible, onClose, onSubmit, initialValues }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && initialValues) {
      form.setFieldsValue({
        ...initialValues,
        // Ensure switch reads boolean correctly
        isMain: initialValues.isMain === true || initialValues.isMain === "true"
      });
    }
  }, [visible, initialValues, form]);

  const handleEditCoupon = async () => {
    try {
      const values = await form.validateFields();
      
      // Combine values for the payload
      const payload = {
        ...initialValues, // Keep existing ID and other fields
        ...values,        // Overwrite with new form values
        isMain: values.isMain || false, // Ensure boolean
      };

      // Call the parent function to handle the API PUT
      onSubmit(payload, initialValues.couponId);
    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  return (
    <Modal
      title="Edit Coupon"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleEditCoupon}
        >
          Update Coupon
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Coupon Name (Code)"
          name="couponName"
          rules={[{ required: true, message: "Please enter the coupon code" }]}
        >
          <Input style={{ textTransform: 'uppercase' }} />
        </Form.Item>

        <div style={{ display: 'flex', gap: '16px' }}>
            <Form.Item
            label="Type"
            name="couponType"
            style={{ flex: 1 }}
            rules={[{ required: true }]}
            >
            <Select>
                <Select.Option value="%">Percentage (%)</Select.Option>
                <Select.Option value="Rs">Flat Amount (₹)</Select.Option>
            </Select>
            </Form.Item>

            <Form.Item
            label="Value"
            name="couponValue"
            style={{ flex: 1 }}
            rules={[{ required: true }]}
            >
            <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
        </div>

        <Form.Item
          label="Minimum Order Amount (Optional)"
          name="minOrderAmount"
          help="Coupon will only work if cart total is above this amount"
        >
          <InputNumber style={{ width: '100%' }} min={0} placeholder="e.g. 500" />
        </Form.Item>

        <Form.Item label="Specific Product ID (Optional)" name="productId">
          <Input placeholder="Leave empty for generic coupon" />
        </Form.Item>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            <Form.Item
            label="Status"
            name="couponStatus"
            style={{ flex: 1 }}
            rules={[{ required: true }]}
            >
            <Select>
                <Select.Option value="active">Active</Select.Option>
                <Select.Option value="inactive">Inactive</Select.Option>
            </Select>
            </Form.Item>

            <Form.Item
            label="Home Page Highlight?"
            name="isMain"
            valuePropName="checked"
            style={{ flex: 1 }}
            >
            <Switch checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default UpdateCouponForm;